import React from 'react';
import * as Connector from 'shared/connectors/partnerConnector';
import { PARTNER } from 'store/types';
import { toast } from 'react-toastify';
import { NewUser } from 'shared/components';
import getPartners from './getPartners';
import { showPreloader, hidePreloader } from '../viewManagement';

const init = () => ({
  type: PARTNER.EDIT_PARTNER_INIT,
});

export const success = data => ({
  type: PARTNER.EDIT_PARTNER_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: PARTNER.EDIT_PARTNER_FAILURE,
});

const editPartner = (partnerData, file) => async dispatch => {
  dispatch(init());
  try {
    dispatch(showPreloader());

    partnerData.provision /= 100;
    const { data } = await Connector.editPartner(partnerData);
    console.log(file, 'plik');
    if (file) {
      const fileForm = new FormData();
      fileForm.append('file', file);
      await Connector.addFile(fileForm, {
        business_partner_uuid: partnerData.uuid,
        file_format: file.type.split('/').pop().split('.')[0],
        file_name: file.name.split('.')[0],
      });
    }
    await dispatch(getPartners());
    await toast(<NewUser badgeType="Partner" first_name={partnerData.name} label="Edytowano partnera" />);
    dispatch(success(data));
    dispatch(hidePreloader());
    return null;
  } catch (err) {
    console.log(err);
    dispatch(failure());
    dispatch(hidePreloader());
    return err.response.data;
  }
};

export default editPartner;
